import { Container } from '@components/Container'
import { Search } from '@components/Search'
import { Pagination } from '@components/Pagination'
import { SearchUserStatusEnum } from '@interfaces/SearchUserStatusEnum'
import { TabSelect } from '@features/user/components/TabSelect'
import { WriterTable } from './components/WriterTable'
import { WriterSubmitPageProps } from './interface'

export function WriterSubmitPage({
  activeTab,
  data,
  page,
  perpage,
  total,
  isLoading,
  userTotal,
  pageChange,
  handleSort,
  handleSubmitSearch,
  handleResetSearch,
  handleUpdateActiveTab,
}: WriterSubmitPageProps) {
  const menusArray = [
    { value: SearchUserStatusEnum.ALL, label: 'ทั้งหมด', total: userTotal.all },
    {
      value: SearchUserStatusEnum.PENDING,
      label: 'รอดำเนินการ',
      total: userTotal.pending,
    },
    {
      value: SearchUserStatusEnum.APPROVED,
      label: 'อนุมัติแล้ว',
      total: userTotal.approved,
    },
    {
      value: SearchUserStatusEnum.REJECTED,
      label: 'ไม่อนุมัติ',
      total: userTotal.rejected,
    },
  ]
  return (
    <Container className='flex flex-col gap-y-[30px]'>
      <h1 className='font-mitr text-[24px] font-medium text-secondary'>
        Writer Submit
      </h1>
      <Search
        placeholder='ค้นหาด้วยชื่อผู้ใช้งาน หรือ ID'
        onSearch={handleSubmitSearch}
        onReset={handleResetSearch}
      />
      <TabSelect
        options={menusArray}
        handleUpdateActiveTab={handleUpdateActiveTab}
        activeTab={activeTab}
      />

      <WriterTable data={data} handleSort={handleSort} isLoading={isLoading} />

      <div className='mt-[-10px]'>
        <Pagination
          page={page}
          perpage={perpage}
          total={total}
          pageChange={pageChange}
        />
      </div>
    </Container>
  )
}
